import axios from "axios"
import { env } from "../constants"

export const list = params => {
    const uri = `${env.startpoint}organizations`
    return axios.get(uri, { params }).then(response => response).catch(error => error.response)
}

export const featured = city => {
    const uri = `${env.startpoint}organizations/featured`
    return axios.get(uri, { params: { city } }).then(response => response).catch(error => error.response)
}

export const get = id => {
    const uri = `${env.startpoint}organizations/${id}`
    return axios.get(uri).then(response => response).catch(error => error.response)
}

export const services = id => {
    const uri = `${env.startpoint}organizations/${id}/services`
    return axios.get(uri).then(response => response).catch(error => error.response)
}

/* Specialists — with the services of the visit only the masters who do all of them come back */
export const specialists = (id, serviceIds = []) => {
    const uri = `${env.startpoint}organizations/${id}/specialists`
    const params = serviceIds.length > 0 ? { serviceIds: serviceIds.join(",") } : {}
    return axios.get(uri, { params }).then(response => response).catch(error => error.response)
}

/* Reveal the full phone number; the backend counts the view */
export const phone = id => {
    const uri = `${env.startpoint}organizations/${id}/phone`
    return axios.get(uri).then(response => response).catch(error => error.response)
}

export const reviews = (id, params, token) => {
    const uri = `${env.startpoint}organizations/${id}/reviews`
    const config = { params }
    if (token) {
        config.headers = { Authorization: `Bearer ${token}` }
    }
    return axios.get(uri, config).then(response => response).catch(error => error.response)
}

export const availability = (id, params) => {
    const uri = `${env.startpoint}organizations/${id}/availability`
    return axios.get(uri, { params }).then(response => response).catch(error => error.response)
}
